var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ActionType } from './types';
export default function mainContextReducer(state, _a) {
    var type = _a.type, payload = _a.payload, rest = __rest(_a, ["type", "payload"]);
    switch (type) {
        case ActionType.SET_ACCOUNT_ID: {
            return __assign(__assign({}, state), { accountId: rest.accountId });
        }
        case ActionType.SET_CONTEXT: {
            return __assign(__assign({}, state), payload);
        }
        case ActionType.SET_CURRENT_LANGUAGE: {
            return __assign(__assign({}, state), { currentLanguage: rest.currentLanguage });
        }
        case ActionType.SET_CURRENT_ROUTE: {
            return __assign(__assign({}, state), { currentRoute: rest.currentRoute });
        }
        case ActionType.SET_AUTOPAY_STATUS: {
            return __assign(__assign({}, state), { autopayStatus: payload === null || payload === void 0 ? void 0 : payload.autopayStatus });
        }
        default: {
            return state;
        }
    }
}
//# sourceMappingURL=reducer.js.map